import colors from 'assets/sass/variables.module.scss';

export const selectColourStyles = (
  bgColor = colors.colorPrimary,
  selectedBgColor = colors.colorPrimaryDark,
  hoverColor = colors.colorPrimaryDark
) => {
  return {
    menu: (provided: any, state: any) => ({
      ...provided,
      width: 'max-content',
      minWidth: '100%',
      color: state.selectProps.menuColor,
      padding: 10
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: state.isSelected ? selectedBgColor : bgColor,
      '&:hover': {
        backgroundColor: hoverColor
      }
    })
  };
};
